import fallingCoinsUrl from '../assets/lottie/chat-effects/falling-coins.json?url';
import fallingCandyUrl from '../assets/lottie/chat-effects/falling-candy.json?url';
import fallingCookiesUrl from '../assets/lottie/chat-effects/falling-cookies.json?url';
import fallingLeavesUrl from '../assets/lottie/chat-effects/falling-leaves.json?url';
import fallingShamrocksUrl from '../assets/lottie/chat-effects/falling-shamrocks.json?url';
import fallingSnowflakesUrl from '../assets/lottie/chat-effects/falling-snowflakes.json?url';
import fireworksShowUrl from '../assets/lottie/chat-effects/fireworks-show.json?url';
import heartBustUrl from '../assets/lottie/chat-effects/heart-bust.json?url';
import megaStarExplosionUrl from '../assets/lottie/chat-effects/mega-star-explosion.json?url';
import pizzaBurstUrl from '../assets/lottie/chat-effects/pizza-burst.json?url';

export type LottieEffectLoader = () => Promise<unknown>;

const animationDataCache = new Map<string, Promise<unknown>>();

const loadLottieJson = (url: string) => {
    const cachedAnimationData = animationDataCache.get(url);

    if (cachedAnimationData) {
        return cachedAnimationData;
    }

    const animationData = fetch(url).then((response) => {
        if (!response.ok) {
            throw new Error(
                `Failed to load Lottie effect JSON: ${response.status} ${response.statusText}`
            );
        }

        return response.json();
    });

    animationDataCache.set(url, animationData);

    return animationData;
};

export const LOTTIE_EFFECT_TRIGGERS: Record<string, LottieEffectLoader> = {
    ':ce-falling-candy': () => loadLottieJson(fallingCandyUrl),
    ':ce-falling-coins': () => loadLottieJson(fallingCoinsUrl),
    ':ce-falling-cookies': () => loadLottieJson(fallingCookiesUrl),
    ':ce-falling-leaves': () => loadLottieJson(fallingLeavesUrl),
    ':ce-falling-shamrocks': () => loadLottieJson(fallingShamrocksUrl),
    ':ce-falling-snowflakes': () => loadLottieJson(fallingSnowflakesUrl),
    ':ce-fireworks-show': () => loadLottieJson(fireworksShowUrl),
    ':ce-heart-bust': () => loadLottieJson(heartBustUrl),
    ':ce-mega-star-explosion': () => loadLottieJson(megaStarExplosionUrl),
    ':ce-pizza-burst': () => loadLottieJson(pizzaBurstUrl),
};

export const isChatLottieEffectTrigger = ({
    ch,
    message,
}: {
    ch?: boolean;
    message?: string;
}) =>
    Boolean(
        ch &&
            message &&
            Object.prototype.hasOwnProperty.call(
                LOTTIE_EFFECT_TRIGGERS,
                message
            )
    );
